<template>
  <div id="app">
  <header class="header_area">
    <div class="main_menu">
      <nav class="navbar navbar-expand-lg navbar-light" id="navbar">
        <div class="container">
          <!-- Brand and toggle get grouped for better mobile display -->
          <a class="navbar-brand logo_h"><img src="img/logo.png"></a>
          <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
           aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style="background-color: black;">
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
            <span class="icon-bar"></span>
          </button>
          <!-- Collect the nav links, forms, and other content for toggling -->
          <div class="collapse navbar-collapse offset" id="navbarSupportedContent">
            <ul class="nav navbar-nav menu_nav justify-content-center">
              <li class="nav-item"><router-link to="/"><a class="nav-link">Home</a></router-link></li>
              <li class="nav-item"><router-link to="/about"><a class="nav-link">About</a></router-link></li>
              <li class="nav-item"><router-link to="/works"><a class="nav-link">Works</a></router-link></li>
              <li class="nav-item submenu dropdown">
                <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                 aria-expanded="false">Products</a>
                <ul class="dropdown-menu">
                  <li class="nav-item"><a class="nav-link" target="_blank" href="https://bell.gitleaf.com">GitLeaf Bell</a></li>
                  <li class="nav-item"><a class="nav-link" target="_blank" href="https://bee.gitleaf.com">GitLeaf Bee Apps</a></li>
                </ul>
              </li>
              <!-- <li class="nav-item submenu dropdown">
                <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" role="button" aria-haspopup="true"
                 aria-expanded="false">Profiles</a>
                <ul class="dropdown-menu">
                  <li class="nav-item"><a class="nav-link" target="_blank" href="https://katheesh.buzz">Owner Profile</a></li>
                </ul>
              </li> -->
              <li class="nav-item"><router-link to="/contact"><a class="nav-link">Contact</a></router-link></li>
            </ul>
            <ul class="nav navbar-nav navbar-right">
              <li class="nav-item"><router-link class="primary_btn text-uppercase" to="/contact">GET A QUOTE</router-link></li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  </header>

  <CookieAlert/>

  <vue-page-transition name="flip-x">
    <router-view/>
  </vue-page-transition>
  </div>
</template>

<style lang="scss">
#navbar {
  a {
    &.router-link-exact-active {
      color: #16a085;
    }
  }
}
</style>
<script>
  import CookieAlert from "@/components/CookieAlert.vue";
  export default {
    components: {
      CookieAlert
    },
    created () {
      window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      handleScroll () {
        let header = document.querySelector(".header_area");
        if (window.scrollY > 50) {
        header.classList.add('navbar_fixed'); 
        } else if (window.scrollY < 50) {
          header.classList.remove('navbar_fixed');
        }
      }
    }
  }
</script>
